import round from 'helpers/mathRound';
import { getAlleDiscount } from 'pages/quotes/helpers';
import { getDiscount } from 'pages/quotes/utils/getDiscount';


export const calculateItemData = (quoteItem, productData) => {
  if (!quoteItem || !productData) {
    return {
      regularPrice: 0,
      savingsValue: 0,
      quoteFrequency: 0,
      unitsName: 'unit',
      subscriptionData: null,
      subtotal: 0,
      discount: 0,
      amount: 0
    };
  }

  const {
    sku,
    qty,
    price: updatedPrice,
    product_option: {
      extension_attributes: {
        subscription_id,
        quotepro_discounts: customQuoteproDiscounts
      }
    }
  } = quoteItem;

  const isAlleSKU = sku.includes('bdsku');

  const {
    price,
    quote_frequency,
    catalog_product_unit = 'units',
    subscription_active,
    quotepro_discounts,
    subscription_options,
    savings,
  } = productData;

  const itemPrice = updatedPrice || price;

  const savingsValue = round(Number(savings)) || 0;
  const quoteFrequency = quote_frequency || 0;

  const dataForDiscount = {
    savings: savingsValue,
    discount_options: quotepro_discounts && quotepro_discounts !== '[]' ? JSON.parse(quotepro_discounts) : [customQuoteproDiscounts],
    itemPrice
  };
  const discount = isAlleSKU
    ? getAlleDiscount(productData) || 0
    : getDiscount(quoteItem, dataForDiscount) || 0;
  const unitsName = catalog_product_unit || 'units';
  const subscriptionData = subscription_options?.find((s: { id: number; }) => s.id === subscription_id);
  const isNullPrice = subscriptionData?.installment_price === null && subscriptionData?.adjustment_price === null;

  const regularPrice = !!subscriptionData && subscription_active === '1' && !isNullPrice && updatedPrice === 0
    ? round(subscriptionData.installment_price + subscriptionData.adjustment_price)
    : itemPrice || 0;

  const subtotal = regularPrice;

  const amount = savingsValue && !updatedPrice
    ? (regularPrice * qty)
    : (regularPrice * qty) - discount;

  return {
    regularPrice,
    savingsValue,
    unitsName,
    quoteFrequency,
    subscriptionData,
    subtotal,
    discount,
    amount: isAlleSKU ? 0 : amount,
    itemPrice,
    updatedPrice
  };
};
